import { render, staticRenderFns } from "./OccurrenceNew.vue?vue&type=template&id=ac501fc6&"
import script from "./OccurrenceNew.vue?vue&type=script&lang=js&"
export * from "./OccurrenceNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports